const dateFormat = {
  en: 'DD/MM/YYYY',
  fr: 'DD/MM/YYYY',
};

export default dateFormat;
